<template>
  <div class="home-page home-wrap">
    <Header></Header>
    <div class="home-index">
      <div class="content crfff ac por">
        <div class="home-content2">
          <!--初级-->
          <span class="level_title">{{$t('Beginner')}}</span>
          <div class="disflex mt30" style="justify-content: center;">
            <div class="home-block2 disflex" @click="getToNav('Hiragana')" >
              <div class="disflex" style="justify-content: center;">
                <div class="">
                  <img src="../../static/images/home-img3.png">
                  <div class="block2-font">
                    <div class="fw7">{{$t('Hiragana')}}</div>
                    <div class="">{{$t('HiraganaTips1')}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="home-block2 disflex" @click="getToNav('Katakana')">
              <div class="disflex" style="justify-content: center;">
                <div class="">
                  <img src="../../static/images/home-img4.png">
                  <div class="block2-font">
                    <div class="fw7">{{$t('katakana')}}</div>
                    <div class="">{{$t('katakanaTips1')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="disflex mt30" style="justify-content: center;">
            <div class="home-block2 disflex" @click="getToNav('Kanji')">
              <div class="disflex" style="justify-content: center;">
                <div class="">
                  <img src="../../static/images/home-img2.png">
                  <div class="block2-font">
                    <div class="fw7">{{$t('Kanji')}}</div>
                    <div class="">{{$t('KanjiTips1')}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="home-block2 disflex" @click="getToNav('Grammar')">
              <div class="disflex" style="justify-content: center;">
                <div class="">
                  <img src="../../static/images/home-img1.png">
                  <div class="block2-font">
                    <div class="fw7">{{$t('Grammar')}}</div>
                    <div class="">{{$t('GrammarTips1')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--中级-->
          <span class="level_title">{{$t('Intermediate')}}</span>
          <section class="communication-activities al">
            <div class="m_section_inner">
              <div
                class=""
                @touchstart="onTouchStart"
                @touchmove="onTouchMove"
                @touchend="onTouchEnd"
                @mousedown="onMouseDown"
                @mousemove="onMouseMove"
                @mouseup="onMouseUp"
                @mouseleave="onMouseLeave"
              >
              <div class="activities-container">
                <div
                  class="activities-wrapper"
                  :style="{
                    transform: `translateX(${translateX}%)`,
                    transition: isDragging ? 'none' : 'transform 0.5s ease'
                  }"
                >
                  <div
                    v-for="(item, index) in topics"
                    :key="index"
                    class="activities-item"
                  >
                    <div class="activities_inner">
                      <div class="disflex topic-header">
                        <div class="topic-number text-shadow">
                          {{item.topic}}
                        </div>
                        <div class="topic-titles">
                          <div class="jp">{{item.title_jp}}</div>
                          <div class="jp"><em>{{item.title_yin}}</em>/{{item.title_en}}</div>
                        </div>
                      </div>
                      <div class="images">
                        <img :src="item.cover_image" :alt="item.title_en">
                      </div>
                      <ul class="lesson-list" :class="{ 'show': activeLesson}">
                        <li v-for="(lesson, lessonIndex) in item.lesson" :key="lessonIndex" class="lesson-item">
                          <div class="lesson-header" @click="toggleLesson(lessonIndex)">
                            <div class="">
                              <div class="lesson-number text-shadow">{{lesson.lesson_num}}</div>
                              <div class="lesson-name">{{lesson.lesson_name}}</div>
                            </div>
                            <div class="lesson-arrow" :class="{ 'open': activeLesson}">
                              ▼
                            </div>
                          </div>
                          <div class="cando" :class="{ 'show': activeLesson}">
                            <a
                              v-for="(activity, activityIndex) in lesson.detail"
                              :key="activityIndex"
                              class="activity-link"
                              @click.prevent="handleActivityClick(activity.id)"
                            >
                              <div class="activity-content">
                                <div class="can-do-name">{{activity.can_do_name_en}}</div>
                                <div class="activity-title">{{activity.title_en}}</div>
                              </div>
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                </div>
                <!-- 导航按钮 -->
                <button
                  class="nav-btn prev-btn"
                  @click="prevSlide"
                  aria-label="Previous"
                  :disabled="currentIndex === 0"
                >
                  ‹
                </button>
                <button
                  class="nav-btn next-btn"
                  @click="nextSlide"
                  aria-label="Next"
                  :disabled="currentIndex === topics.length - 1"
                >
                  ›
                </button>

                <!-- 指示器 -->
                <div class="indicators" role="tablist">
                  <button
                    v-for="(topic, index) in topics"
                    :key="index"
                    :class="['indicator', { 'active': currentIndex === index }]"
                    @click="goToSlide(index)"
                    :aria-label="`Go to slide ${index + 1}`"
                    role="tab"
                  >
                    {{ index + 1 }}
                  </button>
                </div>
              </div>
            </div>
          </section>
          <!--高级-->
          <span class="level_title">{{$t('Advanced')}}</span>
          <div class="home-block5" @click="getToNav('LifeCulture')">
            <img src="../../static/images/home-img5.png">
            <div class="home-block5-c disflex">
              <div class="block2-font">
                <div class="fw7">{{$t('LifeCulture')}}</div>
                <div class="">{{$t('LifeCultureTips1')}}</div>
              </div>
              <div class="learn button" style="font-size: 25px" >{{$t('Learn')}}></div>
            </div>
          </div>
          <div class="home-block5" @click="getToNav('Conversation')">
            <img src="../../static/images/home-img6.png">
            <div class="home-block5-c disflex">
              <div class="block2-font">
                <div class="fw7">{{$t('Conversation')}}</div>
                <div class="">{{$t('ConversationTips1')}}</div>
              </div>
              <div class="learn button" style="font-size: 25px">{{$t('Learn')}}></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 原有底部和弹窗内容 -->
    <div class="footer mt50">
      <div class="home-bottom ac mt50">
        <div class="footer-content ac">
          <a class="crfff" href="#/faq">{{$t('FAQ')}}</a>
          <a class="crfff" href="#/termsAndCondition">{{$t('TC')}}</a>
        </div>
      </div>
      <div class="copyright">{{$t('Copyright')}}</div>
    </div>

    <!-- 原有弹窗组件 -->
    <Dialog ref="levelDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
      <!-- 弹窗内容 -->
    </Dialog>

    <Dialog ref="guidanceDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
      <!-- 弹窗内容 -->
    </Dialog>
  </div>
</template>

<script>
import Header from '../components/IndexHeader'
import Dialog from '../components/dialog'

export default {
  components: {
    Header, Dialog
  },
  data() {
    return {
      isShow: null,
      isEN: 'bur',
      levelModal: false,
      level: 0,
      book: [],
      // 轮播图相关数据
      currentIndex: 0,
      translateX: 0,
      isDragging: false,
      startX: 0,
      currentX: 0,
      dragThreshold: 50, // 拖动阈值
      activeLesson: false, // 当前展开的课程索引
      topics: [],
      autoPlay: true,
      interval: 5000,
      timer: null
    }
  },
  created() {
    this.isEN = localStorage.getItem('lang')
    // this.getUserLevel();
    this.get_book();
    this.startAutoPlay();
    this.updateTranslateX();
  },
  beforeUnmount() {
    this.stopAutoPlay();
  },
  watch: {
    currentIndex() {
      this.updateTranslateX();
      // 切换轮播时关闭所有展开的课程
      this.activeLesson = false;
    }
  },
  methods: {
    getToNav(url) {
      this.$router.push({ path: '/' + url });
    },
    getUserLevel() {
      let that = this;
      that.$parent.loadModal(true);
      that.$api.post('/api/level/info', null, r => {
        that.$parent.returnCode(r, function() {
          that.$parent.loadModal(false);
          that.level = r.data.level;
          if (r.data.level == 0) {
            that.$refs.levelDialog.showMaskFun();
          }
          that.pop_up_level_guidance();
        });
      })
    },
    selectLevel(level) {
      this.$refs.levelDialog.closeMask();
      let that = this;
      if (level >= 1) {
        that.$parent.loadModal(true);
        that.$api.post('/api/level/update', { 'level': level }, r => {
          that.$parent.returnCode(r, function() {
            that.$parent.loadModal(false);
            that.level = r.data.level;
            that.pop_up_level_guidance();
          });
        })
      } else {
        that.$router.push({ path: '/leveltest' });
      }
    },
    get_book() {
      let that = this;
      that.$parent.loadModal(true);
      that.$api.post('/api/activity/list', {}, r => {
        that.$parent.returnCode(r, function() {
          that.$parent.loadModal(false);
          that.topics = r.data;
        });
      })
    },
    goBook(id) {
      this.$router.push({ path: '/BookDetail?id=' + id })
    },
    pop_up_level_guidance() {
      let that = this;
      let is_guidance = localStorage.getItem('is_guidance')
      if (!is_guidance && that.level >= 1) {
        that.$refs.guidanceDialog.showMaskFun();
        localStorage.setItem('is_guidance', true)
      }
    },
    close_level_guidance() {
      let that = this;
      that.$refs.guidanceDialog.closeMask();
    },

    // 轮播图方法
    nextSlide() {
      if (this.currentIndex < this.topics.length - 1) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0; // 循环到第一个
      }
    },
    prevSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      } else {
        this.currentIndex = this.topics.length - 1; // 循环到最后一个
      }
    },
    goToSlide(index) {
      this.currentIndex = index;
    },
    updateTranslateX() {
      this.translateX = this.currentIndex * -100;
    },
    startAutoPlay() {
      return
      if (this.autoPlay && this.topics.length > 1) {
        this.timer = setInterval(() => {
          this.nextSlide();
        }, this.interval);
      }
    },
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    // 课程展开/收起
    toggleLesson(lessonIndex) {
      this.activeLesson = !this.activeLesson
    },

    handleActivityClick(item) {
      this.$router.push({path:'/CommunicationActivities',query: {id:item}});
    },

    // 触摸事件处理 - 每次拖拽滚动整个item
    onTouchStart(e) {
      this.isDragging = true;
      this.startX = e.touches[0].clientX;
      this.currentX = this.startX;
      this.stopAutoPlay();
    },

    onTouchMove(e) {
      if (!this.isDragging) return;
      e.preventDefault();

      this.currentX = e.touches[0].clientX;
      const diff = this.currentX - this.startX;
      // 实时跟随拖动
      this.translateX = this.currentIndex * -100 + (diff / window.innerWidth) * 100;
    },

    onTouchEnd() {
      if (!this.isDragging) return;

      const diff = this.currentX - this.startX;
      const absDiff = Math.abs(diff);

      // 只要拖动就切换，确保每次拖动都切换整个item
      if (absDiff > this.dragThreshold) {
        if (diff > 0) {
          this.prevSlide();
        } else {
          this.nextSlide();
        }
      } else {
        // 拖动距离不足，回到当前位置
        this.updateTranslateX();
      }

      this.isDragging = false;
      this.startAutoPlay();
    },

    // 鼠标事件处理（桌面端）
    onMouseDown(e) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.currentX = this.startX;
      this.stopAutoPlay();
    },

    onMouseMove(e) {
      if (!this.isDragging) return;

      this.currentX = e.clientX;
      const diff = this.currentX - this.startX;
      this.translateX = this.currentIndex * -100 + (diff / window.innerWidth) * 100;
    },

    onMouseUp() {
      if (!this.isDragging) return;

      const diff = this.currentX - this.startX;
      const absDiff = Math.abs(diff);

      if (absDiff > this.dragThreshold) {
        if (diff > 0) {
          this.prevSlide();
        } else {
          this.nextSlide();
        }
      } else {
        this.updateTranslateX();
      }

      this.isDragging = false;
      this.startAutoPlay();
    },

    onMouseLeave() {
      if (this.isDragging) {
        this.isDragging = false;
        this.updateTranslateX();
        this.startAutoPlay();
      }
    }
  }
}
</script>

<style scoped>
/* 原有样式保持不变 */
.disabled {
  opacity: 0.5;
  filter: grayscale(100%);
}

.level_title {
  display: block;
  font-size: 48px;
  font-weight: 700;
  color: #2c3e5e;
  text-align: center;
  margin: 50px 0 30px;
  position: relative;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.level_title::before,
.level_title::after {
  content: '';
  display: inline-block;
  width: 60px;
  height: 3px;
  background: linear-gradient(to right, #ff6600, #ffa633);
  vertical-align: middle;
  margin: 0 20px;
}

</style>



// WEBPACK FOOTER //
// src/page/index.vue